import React from 'react';
import {
  Container, Row,
} from 'reactstrap';
import { ReactTitle } from 'react-meta-tags';
import SearchFiconum from './components/SearchFiconum';
import Results from './components/Results';
import UserInfo from './components/UserInfo';
import callDb from '../../utils/server';
import { getMainCategoryName } from '../../utils/functions';

const LIST_BY_CATEGORIES = {
  numeric: ['cloud', 'data', 'numeric'],
  classic: ['insurance', 'bank', 'estate', 'art', 'other_investment', 'item'],
  professional: ['shop', 'contract', 'company', 'intellectual'],
  planner: ['subscription', 'finance', 'housing'],
};

class Dashboard extends React.Component {
  constructor() {
    super();
    this.state = {
      results: [],
      isShowInfo: false,
      isLoading: false,
      isError: false,
      isLoadedFile: false,
      userInfo: {},
      fileInfo: {},
      search_history: [],
    };
  }

  updateResults = (results) => {
    this.setState({ results });
  };

  toggleInfo = () => {
    this.setState(prevState => ({ isShowInfo: !prevState.isShowInfo }));
  }

  turnToFinal = (data) => {
    const temp = {};
    Object.keys(LIST_BY_CATEGORIES).forEach((key) => {
      LIST_BY_CATEGORIES[key].forEach((item) => {
        const trimmedArray = data.filter(x => x.category === item && !x.linked_company_id);
        if (trimmedArray.length > 0) {
          if (!temp[key]) temp[key] = {};
          temp[key][item] = trimmedArray;
        }
      });
    });
    const final = [];
    Object.keys(temp).forEach((key) => {
      final.push({
        title: getMainCategoryName(key),
        list: temp[key],
      });
    });
    return final;
  }

  openUserInfo = (userInfo) => {
    const { uid } = userInfo;
    console.log(userInfo);
    this.setState({
      isShowInfo: true,
      userInfo,
      isLoading: true,
      isError: false,
    });
    const allInfo = {
      user_id: uid,
    };
    callDb(allInfo, 'ficonum/fetch-user').then((result) => {
      const { data } = result;
      console.log('returned data is: ', data);
      const {
        now, death, last_updated, folders_death, folders_now, notary, testament, contacts_pro, contacts, search_history,
      } = data;
      const finalList = this.turnToFinal(now);
      this.setState({
        isLoading: false,
        rawList: now,
        cleanList: finalList,
        nb_after_death: death,
        nb_folders_after_death: folders_death,
        list_folders: folders_now,
        last_updated,
        list_assets: now,
        notary,
        testament,
        contacts_pro,
        contacts,
        isError: false,
        search_history,
      });
    }).catch((err) => {
      console.log(err);
      this.setState({ isLoading: false, isError: true });
    });
  }

  render() {
    const { results, isShowInfo } = this.state;
    return (
      <Container className="dashboard pt-15">
        <ReactTitle title="FICONUM - By Legitbee" />
        <Container className="dashboard">
          {
            isShowInfo ? (
              <UserInfo {...this.state} toggleInfo={this.toggleInfo} />
            ) : (
              <Row>
                <SearchFiconum updateResults={this.updateResults} />
                {results.length > 0 && <Results results={results} openUserInfo={this.openUserInfo} />}
              </Row>
            )
          }
        </Container>
      </Container>
    );
  }
}

export default Dashboard;
